export default "__VITE_ASSET__BWdvJsqC__"